import { vendorConfigLoadedMessage, sendLocal } from "@sinch/bus";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { loadMFE } from "../../../mfe/mfeLoaders";
import {
  vendorConfigPluginZod,
  type VendorConfigPlugin,
} from "./loadVendorConfigPlugin";

const vendorPluginAtom = atom<VendorConfigPlugin | undefined>(undefined);

export const useVendorConfigPlugin = () => {
  const [vendorPlugin, setVendorPlugin] = useAtom(vendorPluginAtom);
  useEffect(() => {
    if (!vendorPlugin) {
      (async () => {
        const mfe = await loadMFE("container", "vendorConfigs");
        const plugin = mfe as unknown as Record<string, unknown>;
        const addFunctionsPlugin = {
          ...plugin,
          isBrandDirectSMS: () => VENDOR_LABEL === "directSMS",
          isBrandMessageNet: () => VENDOR_LABEL === "messagenet",
          isBrandMobiPost: () => VENDOR_LABEL === "mobipost",
          isBrandStreetData: () => VENDOR_LABEL === "streetdata",
        };
        const parsed = vendorConfigPluginZod.safeParse(addFunctionsPlugin);
        if (parsed.success) {
          setVendorPlugin(parsed.data);
          sendLocal(vendorConfigLoadedMessage());
        } else {
          console.error(
            `${useVendorConfigPlugin.name}: Vendor Config interface has changed, contact mmgp-frontend team for more information`,
            parsed.error
          );
          throw new Error(useVendorConfigPlugin.name + "Error");
        }
      })();
    }
  }, [vendorPlugin, setVendorPlugin]);

  return vendorPlugin;
};
